import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      <a href="#/localMerchant/myShop/regular">等级规则</a>,
      '动态'
    ]

    return (
      <HeaderView title="动态" header={header}>
        <div style={{ padding: '20px 40px' }}>
          <img src="http://qnm.hunliji.com/o_1aa5v84gm5k219861m9isqg1a117.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn519qd7g5shcpcollp1b.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn51tbgt381vl3oju31i1c.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn614l1eb1bng1vgv1vl81d.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa5v8dn61q466gh6a7jde1utn1e.jpg" />
        </div>
      </HeaderView>
    )
  }
}
